// import config from 'config';

/* eslint-disable */
import { authHeader } from '../_helpers';
import { auth_host } from '../constants/service';

export const authService = {
    login,
    logout,
    register,
    verify_email,
    getAll
};

function login(email,token) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',
                    'Authorization': 'Bearer '+token },
        body: JSON.stringify({ email })
    };
    var url = auth_host + `/api/login`;
    return fetch(url, requestOptions);
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('userinfo');
    localStorage.removeItem('tokenExpiry');
    localStorage.removeItem('islogged');
}

function register(email,password,firstname,lastname,phone){
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email,password,firstname,lastname,phone })
    };
    var url = auth_host + `/signup`;
    return fetch(url, requestOptions);
}

function verify_email(email,code){
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email,code })
    };
    var url = auth_host + `/verify/mail`;
    return fetch(url, requestOptions);
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`http://localhost:8080/users`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}